<template>
  <van-tabbar
    v-if="show"
    v-model="active"
    active-color="#f3c7a2"
    :border="true"
    inactive-color="#979799"
    z-index="999"
    class="tabber_view"
  >
    <!-- 首页 -->
    <van-tabbar-item to="/Home">
      <span>{{ $t("foorter.index") }}</span>
      <template #icon="props">
        <img
          :src="props.active ? '/img/neww/zy1.png' : '/img/neww/zy.png'"
          :alt="$t('foorter.index')"
          v-show="show !== 0"
        />
        <img
          :src="props.active ? '/img/neww/zy1.png' : '/img/neww/zy.png'"
          :alt="$t('foorter.index')"
          :class="$t('foorter.index')"
          style="height: 4rem"
          v-show="show === 0"
        />
      </template>
    </van-tabbar-item>
    <!-- 影院 -->
    <van-tabbar-item to="/Choose">
      <span>{{ $t("foorter.Feedback") }} </span>
      <template #icon="props">
        <img
          :src="props.active ? '/img/neww/yh1.png' : '/img/neww/yh.png'"
          :alt="$t('foorter.subscribe')"
          v-show="show !== 1"
        />
        <img
          :src="props.active ? '/img/neww/yh1.png' : '/img/neww/yh.png'"
          :alt="$t('foorter.subscribe')"
          :class="$t('foorter.subscribe')"
          style="height: 4rem"
          v-show="show === 1"
        />
      </template>
    </van-tabbar-item>

    <!-- 视频 -->
    <van-tabbar-item to="/Lottery">
      <span>{{ $t("foorter.video") }}</span>
      <template #icon="props">
        <img
          :src="props.active ? '/img/neww/dt1.png' : '/img/neww/dt.png'"
          :alt="$t('foorter.xuanfei')"
          v-show="show !== 2"
        />
        <img
          :src="props.active ? '/img/neww/dt1.png' : '/img/neww/dt.png'"
          :alt="$t('foorter.xuanfei')"
          :class="$t('foorter.xuanfei')"
          style="height: 4rem"
          v-show="show === 2"
        />
      </template>
    </van-tabbar-item>
<van-tabbar-item to="/vip">
      <span>{{ $t("svip") }}</span>
      <template #icon="props">
        <img
          :src="props.active ? '/img/neww/12.png' : '/img/neww/12.png'"
          :alt="$t('SVIP')"
          v-show="show !== 3"
        />
        <img
          :src="props.active ? '/img/neww/12.png' : '/img/neww/12.png'"
          :alt="$t('SVIP')"
          :class="$t('SVIP')"
          style="height: 4rem"
          v-show="show === 3"
        />
      </template>
    </van-tabbar-item>
    <!-- <van-tabbar-item to="/Video">
      <span>{{ $t("foorter.subscribe") }}</span>
      <template #icon="props">
        <img
          :src="props.active ? '/img/neww/video1.png' : '/img/neww/video.png'"
          :alt="$t('foorter.video')"
          v-show="show !== 3"
        />
        <img
          :src="props.active ? '/img/neww/video1.png' : '/img/neww/video.png'"
          :alt="$t('foorter.video')"
          :class="$t('foorter.video')"
          style="height: 4rem"
          v-show="show === 3"
        />
      </template>
    </van-tabbar-item> -->
    <!-- 我的 -->
    <van-tabbar-item to="/Mine">
      <span>{{ $t("foorter.my") }}</span>
      <template #icon="props">
        <img
          :src="props.active ? '/img/neww/wd1.png' : '/img/neww/wd.png'"
          :alt="$t('foorter.my')"
          v-show="show !== 4"
        />
        <img
          :src="props.active ? '/img/neww/wd1.png' : '/img/neww/wd.png'"
          :alt="$t('foorter.my')"
          :class="$t('foorter.my')"
          style="height: 4rem"
          v-show="show === 4"
        />
      </template>
    </van-tabbar-item>
  </van-tabbar>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      active: 0,
    };
  },
  methods: {},
  watch: {
    $route(to) {
      if (to.name == "home") {
        this.active = 0;
        this.show = true;
      } else if (to.name == "choose") {
        this.active = 1;
        this.show = true;
      } else if (to.name == "Lottery") {
        this.active = 2;
        this.show = true;
      } else if (to.name == "vip") {
        this.active = 3;
        this.show = true;
      } else if (to.name == "mine") {
        this.active = 4;
        this.show = true;
      } else {
        this.show = false;
      }
    },
  },
  created() {
    if (this.$route.name == "home") {
      this.active = 0;
      this.show = true;
    } else if (this.$route.name == "choose") {
      this.active = 1;
      this.show = true;
    } else if (this.$route.name == "Lottery") {
      this.active = 2;
      this.show = true;
    } else if (this.$route.name == "video") {
      this.active = 3;
      this.show = true;
    } else if (this.$route.name == "mine") {
      this.active = 4;
      this.show = true;
    } else {
      this.show = false;
    }
  },
};
</script>

<style lang="less" scoped>
@tabbar-height: 110px;
@tabbar-img: 75px;
.tabber_view {
  background-color: #1f1c1f;
}
.van-tabbar {
  height: @tabbar-height;
}
.van-tabbar-item__icon img {
  height: 7vw;
}
.van-tabbar-item {
  font-size: 26px;
}
.tui {
  width: 4rem;
  height: 4rem !important;
  margin-top: -7.333vw;
  background-color: white;
  border-radius: 50%;
  border: 10px solid white;
  z-index: 10;
}
[class*="van-hairline"]::after {
  border: none !important;
}
::v-deep .van-tabbar-item--active {
  background-color: transparent;
}

@media screen and (min-width: 1024px) {
  ::v-deep.van-tabbar-item span {
    font-size: 18px; // 字体大小
    display: block;
    text-align: center; // 居中文字
  }
  ::v-deep.van-tabbar {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    width: 430px;
    margin: 0 auto;
    height: 50px;
  }

  .van-tabbar-item__icon img {
    height: 20px;
  }
}
</style>
